/** Clés login / marque auth partagées (FR / AR) */
export const authPageLoginFr = {
  brandSubtitle: 'Plateforme Retail Entreprise',
  brandTagline: 'Le commerce, maîtrisé de bout en bout.',
  brandDescription: 'Stock · Caisse · Paiements',
  createBusinessAccount: 'Créer un compte entreprise',
  createBusinessAccountDesc: 'Inscrivez votre entreprise pour commencer à gérer votre stock',
  loginTitle: 'Bon retour',
  loginWelcome: 'Bienvenue',
  loginDescription: 'Connectez-vous pour accéder à votre espace de travail.',
  noAccountYet: 'Pas encore de compte ? S\'inscrire',
  usernameLabel: 'Nom d\'utilisateur',
  usernamePlaceholder: ' ',
  passwordLabel: 'Mot de passe',
  passwordPlaceholder: ' ',
  signIn: 'Se connecter',
  forgotPasswordLink: 'Mot de passe oublié ?',
  rememberMe: 'Se souvenir de moi',
  newBusiness: 'Nouvelle entreprise ?',
  createAccount: 'Créer un compte entreprise',
  companyName: 'Easy Soft Solution',
  copyright: '© {{year}} Easy Soft Solution. Tous droits réservés.',
  versionLabel: 'v{{version}}',
  errNoInternet: 'Pas de connexion Internet — utilisez votre compte local.',
  errNoLocalWaitCloud: 'Aucun compte local trouvé. Créez un compte ou attendez l\'approbation admin (compte cloud).',
  errNoLocalUseRegister: 'Aucun compte local enregistré. Utilisez « Créer un compte » ou vérifiez identifiant/mot de passe.',
  errNoLocalLoginOnly: 'Identifiant ou mot de passe incorrect. Cette installation est déjà configurée — seule la connexion est possible.',
  errNoLocalCreate: 'Aucun compte local enregistré — créez un compte entreprise.',
  errInvalidCredentials: 'Nom d\'utilisateur ou mot de passe incorrect',
  errWrongPasswordLocal:
    'Mot de passe incorrect (local ou cloud). Utilisez le mot de passe d’inscription / d’Upgrade Cloud. Sur le web, si le compte n’est pas encore approuvé, l’admin doit l’activer d’abord.',
  errUseRegisteredUsername: 'Identifiant incorrect. Utilisez le nom d\'utilisateur enregistré : {{username}} (ou l\'e-mail d\'inscription).',
  errPasswordLostOffline: 'Compte trouvé mais mot de passe absent sur ce PC. Utilisez « Mot de passe oublié » pour en définir un nouveau (sans Internet).',
  authRepairRunning: 'Réparation des données de connexion…',
  authRepairDoneRetry: 'Données locales réparées — réessayez votre mot de passe d\'inscription.',
  authRepairDoneNoPassword: 'Compte trouvé. Mot de passe introuvable dans la mémoire locale — utilisez « Mot de passe oublié ».',
  authRepairHintForgot: 'Si le mot de passe ne fonctionne pas, cliquez sur « Mot de passe oublié » (fonctionne hors ligne).',
  debugShowDetails: 'Afficher les détails techniques',
  debugHideDetails: 'Masquer les détails',
  debugYes: 'Oui',
  debugNo: 'Non',
  debugEnteredLogin: 'Identifiant saisi',
  debugOnline: 'Internet',
  debugLocalAccounts: 'Comptes locaux',
  debugAccountFound: 'Compte trouvé',
  debugBusinessId: 'ID entreprise',
  debugUsername: 'Nom d\'utilisateur',
  debugEmail: 'E-mail',
  debugPasswordInLocalStorage: 'Mot de passe dans localStorage (AppData)',
  debugPasswordInIndexedDb: 'Mot de passe dans IndexedDB',
  debugPasswordInOfflineUsers: 'Mot de passe dans offline_users (localStorage)',
  debugManagerCodePresent: 'Code gestionnaire enregistré',
  debugLsBusinessBytes: 'Taille offline_businesses (localStorage)',
  debugLsBusinessCount: 'Entrées dans localStorage',
  debugLsError: 'Erreur localStorage',
  debugHintForgotPassword: '→ Mot de passe absent localement : utilisez « Mot de passe oublié » avec votre code gestionnaire ou NIF.',
  debugHintWrongPassword: '→ Mot de passe présent mais incorrect, ou utilisez « Mot de passe oublié ».',
  debugHintNoAccount: '→ Aucun compte local pour cet identifiant.',
  errConnection: 'Erreur de connexion. Veuillez vérifier votre connexion et réessayer.',
  errInstallBinding: 'Cette installation est liée à un autre ordinateur. Connexion impossible sur ce PC.',
  errMachineBinding: 'Ce compte est lié à un autre ordinateur. Connexion impossible ici.',
  errBindFailed: 'Échec de la liaison à cet ordinateur.',
  loginFormHelp: 'Déjà inscrit ? Utilisez le formulaire ci-dessous.',
  loginOnlyInstallation: 'Cette installation est déjà configurée. Connectez-vous avec votre compte.',
  registerHintLink: 'Pas encore de compte ? S\'inscrire',
  loginModeBusiness: 'Entreprise',
  loginModeWorker: 'Caissier',
  workerNameLabel: 'Nom de l\'employé',
  workerNamePlaceholder: ' ',
  workerCodeLabel: 'Code employé',
  workerCodePlaceholder: ' ',
  workerLoginHint: 'Utilisez le nom et le code créés par le gestionnaire dans les paramètres.',
  errWorkerNameCodeRequired: 'Nom et code employé requis',
  errInvalidWorkerCredentials: 'Nom ou code employé incorrect',
  errWorkerDeactivated: 'Cet employé est désactivé. Contactez le gestionnaire.',
  errCashRegisterPaused: 'Caisse en pause. Seul le caissier qui l\'a mise en pause peut se reconnecter — aucun autre caissier ne peut entrer.',
  errNoLocalBusinessForWorker: 'Aucune entreprise locale trouvée. Le gestionnaire doit d\'abord créer un compte.',
  statusOnline: 'En ligne',
  statusOffline: 'Hors ligne',
  brandFeatureOffline: 'Fonctionne aussi hors ligne',
  featurePos: 'Point de vente',
  featureInventory: 'Gestion de stock',
  featurePurchasing: 'Achats',
  featureCrm: 'Clients (CRM)',
  featureMultiStore: 'Multi-magasins',
  featureOffline: 'Mode hors ligne',
  featureCloud: 'Synchronisation cloud',
  featureLanguages: 'Arabe & Français'
};

export const authPageLoginAr = {
  brandSubtitle: 'منصة التجزئة للمؤسسات',
  brandTagline: 'إدارة تجارتك، من البداية إلى النهاية.',
  brandDescription: 'المخزون · الصندوق · المدفوعات',
  createBusinessAccount: 'إنشاء حساب شركة',
  createBusinessAccountDesc: 'سجّل شركتك للبدء في إدارة مخزونك',
  loginTitle: 'مرحباً بعودتك',
  loginWelcome: 'مرحباً',
  loginDescription: 'سجّل الدخول للوصول إلى مساحة عملك.',
  noAccountYet: 'ليس لديك حساب؟ سجّل الآن',
  usernameLabel: 'اسم المستخدم',
  usernamePlaceholder: ' ',
  passwordLabel: 'كلمة المرور',
  passwordPlaceholder: ' ',
  signIn: 'تسجيل الدخول',
  forgotPasswordLink: 'نسيت كلمة المرور؟',
  rememberMe: 'تذكرني',
  newBusiness: 'شركة جديدة؟',
  createAccount: 'إنشاء حساب شركة',
  companyName: 'Easy Soft Solution',
  copyright: '© {{year}} Easy Soft Solution. جميع الحقوق محفوظة.',
  versionLabel: 'v{{version}}',
  errNoInternet: 'لا يوجد اتصال بالإنترنت',
  errNoLocalWaitCloud: 'لا يوجد حساب محلي. سجّل حساباً جديداً أو انتظر موافقة المسؤول على حساب السحابة.',
  errNoLocalUseRegister: 'لا يوجد حساب محلي محفوظ. استخدم «إنشاء حساب» أو تحقق من اسم المستخدم/كلمة المرور.',
  errNoLocalLoginOnly: 'اسم المستخدم أو كلمة المرور غير صحيحة. هذا التثبيت مُعدّ مسبقاً — تسجيل الدخول فقط.',
  errNoLocalCreate: 'لا يوجد حساب محلي. أنشئ حساباً جديداً.',
  errInvalidCredentials: 'اسم المستخدم أو كلمة المرور غير صحيحة',
  errWrongPasswordLocal:
    'كلمة المرور غير صحيحة (محلي أو سحابة). استخدم كلمة مرور التسجيل / Upgrade Cloud. على الويب: إن لم يُعتمد الحساب بعد، يجب أن يفعّله المسؤول أولاً.',
  errUseRegisteredUsername: 'المعرّف غير صحيح. استخدم اسم المستخدم المسجل: {{username}} (أو البريد من التسجيل).',
  errPasswordLostOffline: 'تم العثور على الحساب لكن كلمة المرور غير موجودة على هذا الجهاز. استخدم «نسيت كلمة المرور» لتعيين كلمة جديدة (بدون إنترنت).',
  authRepairRunning: 'جاري إصلاح بيانات تسجيل الدخول…',
  authRepairDoneRetry: 'تم إصلاح البيانات المحلية — أعد إدخال كلمة المرور من التسجيل.',
  authRepairDoneNoPassword: 'تم العثور على الحساب. كلمة المرور غير موجودة محلياً — استخدم «نسيت كلمة المرور».',
  authRepairHintForgot: 'إذا لم تنجح كلمة المرور، اضغط «نسيت كلمة المرور» (يعمل بدون إنترنت).',
  debugShowDetails: 'عرض التفاصيل التقنية',
  debugHideDetails: 'إخفاء التفاصيل',
  debugYes: 'نعم',
  debugNo: 'لا',
  debugEnteredLogin: 'المعرّف المدخل',
  debugOnline: 'الإنترنت',
  debugLocalAccounts: 'الحسابات المحلية',
  debugAccountFound: 'تم العثور على الحساب',
  debugBusinessId: 'معرّف الشركة',
  debugUsername: 'اسم المستخدم',
  debugEmail: 'البريد الإلكتروني',
  debugPasswordInLocalStorage: 'كلمة المرور في localStorage (AppData)',
  debugPasswordInIndexedDb: 'كلمة المرور في IndexedDB',
  debugPasswordInOfflineUsers: 'كلمة المرور في offline_users (localStorage)',
  debugManagerCodePresent: 'رمز المدير مسجل',
  debugLsBusinessBytes: 'حجم offline_businesses (localStorage)',
  debugLsBusinessCount: 'إدخالات في localStorage',
  debugLsError: 'خطأ localStorage',
  debugHintForgotPassword: '→ كلمة المرور غير موجودة محلياً: استخدم «نسيت كلمة المرور» مع رمز المدير أو NIF.',
  debugHintWrongPassword: '→ كلمة المرور موجودة لكن غير صحيحة، أو استخدم «نسيت كلمة المرور».',
  debugHintNoAccount: '→ لا يوجد حساب محلي لهذا المعرّف.',
  errConnection: 'خطأ في الاتصال. يرجى التحقق من الاتصال والمحاولة مرة أخرى.',
  errInstallBinding: 'هذا التثبيت مرتبط بجهاز آخر. لا يمكن تسجيل الدخول على هذا الحاسوب.',
  errMachineBinding: 'هذا الحساب مرتبط بجهاز آخر. لا يمكن تسجيل الدخول هنا.',
  errBindFailed: 'فشل ربط الجهاز.',
  loginFormHelp: 'تسجيل الدخول للعملاء الحاليين في النموذج أدناه',
  loginOnlyInstallation: 'هذا التثبيت مُعدّ مسبقاً. سجّل الدخول بحساب شركتك.',
  registerHintLink: 'إنشاء حساب جديد',
  loginModeBusiness: 'المؤسسة',
  loginModeWorker: 'الصندوق',
  workerNameLabel: 'اسم الموظف',
  workerNamePlaceholder: ' ',
  workerCodeLabel: 'رمز الموظف',
  workerCodePlaceholder: ' ',
  workerLoginHint: 'استخدم الاسم والرمز اللذين أنشأهما المدير في الإعدادات.',
  errWorkerNameCodeRequired: 'الاسم ورمز الموظف مطلوبان',
  errInvalidWorkerCredentials: 'اسم أو رمز الموظف غير صحيح',
  errWorkerDeactivated: 'هذا الموظف غير نشط. تواصل مع المدير.',
  errCashRegisterPaused: 'الصندوق متوقف. فقط أمين الصندوق الذي أوقفه يمكنه إعادة الدخول — لا يمكن لأي كاشير آخر الدخول.',
  errNoLocalBusinessForWorker: 'لا توجد شركة محلية. يجب على المدير إنشاء حساب أولاً.',
  statusOnline: 'متصل',
  statusOffline: 'غير متصل',
  brandFeatureOffline: 'يعمل بدون اتصال بالإنترنت',
  featurePos: 'نقطة البيع',
  featureInventory: 'إدارة المخزون',
  featurePurchasing: 'المشتريات',
  featureCrm: 'إدارة العملاء',
  featureMultiStore: 'متعدد الفروع',
  featureOffline: 'يعمل دون اتصال',
  featureCloud: 'مزامنة سحابية',
  featureLanguages: 'العربية والفرنسية'
};
